module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-layout', {
    attrs: {
      "ShowBottomBar": false,
      "NeedLogin": false,
      "ResizeCallback": _vm.Resize
    }
  }, [_c('div', {
    staticClass: "definition"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    staticClass: "iconMark",
    attrs: {
      "src": require("../assets/img/dictionary.svg")
    }
  }), _vm._v(" xAPI Verbs\n                    ")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "95%",
      "font-size": "small"
    },
    style: ({
      height: this.TableHeight + 'px'
    }),
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "Name",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Description",
      "label": "Description"
    }
  })], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df7fa89a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Schema.vue
// module id = 488
// module chunks = 2